/** Polling interval for active jobs (ms) — safety net fallback for WebSocket */
export const JOB_POLL_INTERVAL_MS = 30_000;

/** Polling interval for notifications (ms) */
export const NOTIFICATION_POLL_INTERVAL_MS = 60_000;

/** Polling interval for user profile (ms) */
export const PROFILE_POLL_INTERVAL_MS = 60_000;

/** Number of days shown in the activity chart */
export const ACTIVITY_CHART_DAYS = 7;

/** Multipart upload threshold (bytes) — files larger than this use multipart */
export const MULTIPART_UPLOAD_THRESHOLD_BYTES = 5 * 1024 * 1024;

/** API request timeout (ms) */
export const API_TIMEOUT_MS = 30_000;

/** Forum trending score: weight for replies in the last 7 days */
export const TRENDING_REPLY_WEIGHT = 2;

/** Forum trending score: weight for net votes in the last 7 days */
export const TRENDING_VOTE_WEIGHT = 1;

/** Trending window (ms) — 7 days */
export const TRENDING_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

/** WebSocket heartbeat interval (ms) — sends keepalive every 5 minutes to refresh TTL */
export const WS_HEARTBEAT_INTERVAL_MS = 5 * 60 * 1_000;

/** WebSocket reconnect base delay (ms) — exponential backoff starts here */
export const WS_RECONNECT_BASE_MS = 1_000;

/** WebSocket reconnect max delay (ms) — backoff caps at 30 seconds */
export const WS_RECONNECT_MAX_MS = 30_000;

/** WebSocket visibility disconnect threshold (ms) — disconnect after 10 min hidden */
export const WS_VISIBILITY_DISCONNECT_MS = 10 * 60 * 1_000;
